<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import SbRichtext from '$lib/storyblok/components/sbRichtext.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLDivElement> {
		content: ISbStoryData<{
			title: ISbRichtext;
			text: string;
			button: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="bg-gradient px-5 pb-14 pt-10 lg:py-[68px] lg:text-center">
	<div class="font-rhymes text-[68px]/[94%] font-light tracking-[-2.04px] text-[#79D397]">
		<SbRichtext text={content.title} />
	</div>

	<p
		class="mt-5 max-w-[488px] text-[16px]/[150%] text-[#F8F4EB] lg:mx-auto lg:text-[20px]/[140%] lg:tracking-[-.2px]"
	>
		{content.text}
	</p>

	{#if content.button?.length > 0}
		<div class="mt-12 flex lg:justify-center">
			<Blok content={content.button[0]} />
		</div>
	{/if}
</div>

<style>
	.bg-gradient {
		background: linear-gradient(0deg, #2d6751 0%, #194334 100%);
	}
</style>
